import { useEffect, useState } from "react";
import { cn } from "@/lib/utils.ts";
import { useAuth } from "@/hooks/useAuth.ts";
import { LanguageSwitcher } from "@/components/LanguageSwitcher.tsx";
import { ThemeToggle } from "@/components/ThemeToggle.tsx";
import { AIProviderButton } from "@/components/ai/AIProviderButton.tsx";
import { AIProviderModal } from "@/components/ai/AIProviderModal.tsx";

type SettingsControlsProps = {
  className?: string;
};

export function SettingsControls({ className }: SettingsControlsProps) {
  const { provider } = useAuth();
  const [showAIModal, setShowAIModal] = useState(false);
  const [selectedModel, setSelectedModel] = useState<string>("");

  useEffect(() => {
    if (provider) {
      try {
        const saved = localStorage.getItem(`ai_model_${provider}`) || "";
        setSelectedModel(saved);
      } catch {
        setSelectedModel("");
      }
      return;
    }
    setSelectedModel("");
  }, [provider]);

  return (
    <>
      <div className={cn("flex items-center gap-2 text-foreground", className)}>
        <LanguageSwitcher />
        <ThemeToggle />
        <AIProviderButton
          onClick={() => setShowAIModal(true)}
        />
      </div>

      <AIProviderModal
        open={showAIModal}
        onOpenChange={setShowAIModal}
        selectedModel={selectedModel}
        onModelChange={setSelectedModel}
      />
    </>
  );
}
